import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    "nav.about": "About", "nav.services": "Services", "nav.fleet": "Fleet", "nav.coverage": "Coverage",
    "nav.industries": "Industries", "nav.gallery": "Gallery", "nav.careers": "Careers", "nav.contact": "Contact",
    "nav.quote": "Get a Quote",
    "hero.badge": "Abu Dhabi · Est. 2023 · 20+ Years Experience",
    "hero.tagline": "Moving Loads. Building Trust. Premium transportation from Abu Dhabi to every corner of the Gulf — flatbed, container and heavy-haul, on time, every time.",
    "hero.explore": "Explore Services", "hero.contact": "Contact Us",
    "hero.stat1": "Years of Experience", "hero.stat2": "Fleet Vehicles", "hero.stat3": "GCC Countries", "hero.stat4": "Deliveries Completed",
    "hero.scroll": "Scroll to begin the journey",
    "quick.title": "Quick Inquiry",
    "quick.name": "Your Name", "quick.phone": "WhatsApp Number", "quick.submit": "Send",
    "contact.eyebrow": "End of the Journey",
    "contact.title": "The truck is parked. Let's talk.",
    "contact.desc": "Tell us what you need moved and where — a dedicated coordinator replies within one working day.",
    "contact.phone": "Phone", "contact.email": "Email", "contact.hours": "Working Hours", "contact.office": "Head Office",
    "form.name": "Full Name", "form.company": "Company", "form.phone": "Phone", "form.email": "Email",
    "form.service": "Select a Service", "form.message": "Tell us about your shipment…",
    "form.submit": "Submit Inquiry", "form.whatsapp": "WhatsApp",
    "footer.links": "Quick Links", "footer.services": "Services", "footer.serve": "We Serve",
    "footer.rights": "All rights reserved.", "footer.tag": "Serving the Entire GCC",
    "careers.eyebrow": "Careers", "careers.title": "Drive with Mandair.",
    "careers.desc": "Join a growing fleet moving the GCC's heaviest cargo. Apply below — your application goes straight to our HR inbox.",
    "careers.openings": "Current Openings", "careers.apply": "Apply Now",
    "careers.formtitle": "Driver Application",
    "careers.license": "License Type", "careers.experience": "Years of Experience",
    "careers.cv": "Upload CV (PDF/DOC)", "careers.message": "Tell us about yourself…",
    "careers.submit": "Submit Application",
  },
  ar: {
    "nav.about": "عن الشركة", "nav.services": "خدماتنا", "nav.fleet": "الأسطول", "nav.coverage": "التغطية",
    "nav.industries": "القطاعات", "nav.gallery": "المعرض", "nav.careers": "الوظائف", "nav.contact": "اتصل بنا",
    "nav.quote": "اطلب عرض سعر",
    "hero.badge": "أبوظبي · تأسست 2023 · خبرة تتجاوز 20 عامًا",
    "hero.tagline": "نقل الأحمال. بناء الثقة. نقل بري متميز من أبوظبي إلى كل دول مجلس التعاون — نقل مسطح وحاويات ومعدات ثقيلة، في الموعد كل مرة.",
    "hero.explore": "استكشف الخدمات", "hero.contact": "اتصل بنا",
    "hero.stat1": "سنوات الخبرة", "hero.stat2": "مركبة في الأسطول", "hero.stat3": "دولة خليجية", "hero.stat4": "عملية تسليم",
    "hero.scroll": "مرر لبدء الرحلة",
    "quick.title": "استفسار سريع",
    "quick.name": "الاسم", "quick.phone": "رقم الواتساب", "quick.submit": "إرسال",
    "contact.eyebrow": "نهاية الرحلة",
    "contact.title": "الشاحنة متوقفة. لنتحدث.",
    "contact.desc": "أخبرنا بما تحتاج نقله وإلى أين — يرد عليك منسق مخصص خلال يوم عمل واحد.",
    "contact.phone": "الهاتف", "contact.email": "البريد الإلكتروني", "contact.hours": "ساعات العمل", "contact.office": "المقر الرئيسي",
    "form.name": "الاسم الكامل", "form.company": "الشركة", "form.phone": "رقم الهاتف", "form.email": "البريد الإلكتروني",
    "form.service": "اختر الخدمة", "form.message": "أخبرنا عن شحنتك…",
    "form.submit": "إرسال الاستفسار", "form.whatsapp": "واتساب",
    "footer.links": "روابط سريعة", "footer.services": "خدماتنا", "footer.serve": "نخدم",
    "footer.rights": "جميع الحقوق محفوظة.", "footer.tag": "نخدم دول مجلس التعاون كاملة",
    "careers.eyebrow": "الوظائف", "careers.title": "قد مع مندير.",
    "careers.desc": "انضم إلى أسطول متنامٍ ينقل أثقل البضائع في الخليج. قدّم طلبك أدناه — يصل مباشرة إلى بريد الموارد البشرية.",
    "careers.openings": "الوظائف المتاحة", "careers.apply": "قدّم الآن",
    "careers.formtitle": "طلب توظيف سائق",
    "careers.license": "نوع الرخصة", "careers.experience": "سنوات الخبرة",
    "careers.cv": "ارفع السيرة الذاتية (PDF/DOC)", "careers.message": "حدثنا عن نفسك…",
    "careers.submit": "إرسال الطلب",
  },
};

const LangContext = createContext(null);

export const useLang = () => useContext(LangContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => dict[lang][key] || dict.en[key] || key;

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};
